<div class="vtr-widget-about"
	id="about-dialog" aria-hidden="false">
	<div id="about-modal-basic-title" hidden>{{'support.quicklinks.listAboutLenovoVantage' | translate}}</div>
	<div class="content">
		<div class="img-con pt-4"
			role="img" 
			aria-label="Lenovo Vantage Logo"
			id="about-modal-lenovo-vantage-logo">
			<svg class="qr-img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><defs><style>.a{fill:#e1140a;}.b{fill:#fff;}.c{fill:#590804;}</style></defs>
				<rect class="a" width="256" height="256"/><polygon class="b" points="197.43 166.56 119.26 166.56 119.26 35.43 84.4 35.43 84.4 198.14 197.43 198.14 197.43 166.56"/><polygon class="c" points="54.6 215.2 84.4 198.14 197.43 198.14 54.6 215.2"/><polygon class="c" points="54.6 215.2 84.4 198.14 84.4 41.78 54.6 215.2"/>
			</svg>
		</div>
		<div id="about-modal-title" class="text-center title mb-2" role="text">{{'appTitle' | translate}} {{'appName' | translate}}</div>
		<div id="about-modal-description" class="text-center description" role="text">
			{{ 'support.about.version' | translate}}: {{ shellVersion }} <br>
			( Web: {{ buildVersion }}&nbsp;&nbsp;Bridge: {{ bridgeVersion }} )
		</div>
	</div>
	<div class="line"></div>
	<div class="about-links mb-4 text-center">
		<div class="mb-2">
			<a id="about-modal-license-link"
				href="javascript:;"
				class="mr-1"
				(click)="agreementClicked()">{{ 'support.about.licenseAgreement' | translate}}</a>
			|
			<a id="about-modal-other-licenses-link"
				href="javascript:;"
				class="ml-1"
				(click)="openSourceClicked()">{{ 'support.about.otherSoftwareLicenses' | translate}}</a>
		</div>
		<div class="mb-2">
			<a id="about-modal-web-link"
				href="https://www.lenovo.com"
				class="mr-1"
				target="_blank">{{ 'support.about.ourWebsite' | translate}}</a>
			|
			<a id="about-modal-user-guide-link"
				href="javascript:;"
				class="ml-1"
				(click)="launchUserGuide()">{{ 'support.about.aboutYourDevice' | translate}}</a>
		</div>
		<div id="about-modal-copyright" role="text">{{ 'support.about.copyright' | translate}}</div>
	</div>

	<div role="button"
		class="close-btn"
		aria-label="close"
		tabindex="0"
		(keydown.enter)="closeModal()"
		(click)="closeModal()">
		<img [src]=" 'assets/icons/Close.svg' | svgInline | async"
			alt=""
			srcset="">
    </div>
</div>
